import React from 'react';
import Sparkline from './Sparkline';
import { money, signed, pct, tone, mmdd } from './format';

// finpilot's arr_color: ≥20 bold green, ≥10 green, ≥0 yellow, else red.
const arrTone = a => (a >= 20 ? 'up strong' : a >= 10 ? 'up' : a >= 0 ? 'warn' : 'down');

export default function Performance({ data }) {
  const monthly = data.monthly || [];
  const t = data.totals || {};
  const symbols = data.symbols || [];
  const nets = monthly.map(r => r.net);

  return (
    <div className="df-performance">
      <p className="df-line">
        <span>options income</span>
        <b className={tone(t.net)}>{signed(t.net)}</b>
        <span>{t.trades ?? 0} trades</span>
        <span className={arrTone(t.avg_arr ?? 0)}>{pct(t.avg_arr ?? 0, 1)} avg arr</span>
        <span className="df-muted">as of {mmdd(data.taken_at)}</span>
      </p>

      {nets.length > 1 && <Sparkline values={nets.map(n => Math.max(0, n))} width={600} height={36} />}

      <div className="df-grid">
        <article className="df-wide">
          <header><h3>monthly performance</h3><span className="df-muted">ytd</span></header>
          {monthly.length === 0 ? <p className="df-muted">no option transactions this year</p> : (
            <table className="df-table">
              <thead>
                <tr>
                  <th>month</th><th className="df-num">collected</th><th className="df-num">paid</th>
                  <th className="df-num">net p/l</th><th className="df-num">trades</th><th className="df-num">arr</th>
                </tr>
              </thead>
              <tbody>
                {monthly.map(r => (
                  <tr key={r.month}>
                    <td>{r.label}</td>
                    <td className="df-num">{money(r.received)}</td>
                    <td className="df-num">{money(r.paid)}</td>
                    <td className={`df-num ${tone(r.net)}`}>{signed(r.net)}</td>
                    <td className="df-num">{r.trades}</td>
                    <td className={`df-num ${arrTone(r.arr)}`}>{pct(r.arr, 1)}</td>
                  </tr>
                ))}
                <tr className="df-total">
                  <td>average</td>
                  <td className="df-num">{money(t.received)}</td>
                  <td className="df-num">{money(t.paid)}</td>
                  <td className={`df-num ${tone(t.net)}`}>{signed(t.net)}</td>
                  <td className="df-num">{t.trades}</td>
                  <td className={`df-num ${arrTone(t.avg_arr ?? 0)}`}>{pct(t.avg_arr ?? 0, 1)}</td>
                </tr>
              </tbody>
            </table>
          )}
        </article>

        <article className="df-wide">
          <header><h3>top symbols by p/l</h3><span className="df-muted">last {data.months ?? 6} months</span></header>
          {symbols.length === 0 ? <p className="df-muted">no option transactions in this window</p> : (
            <table className="df-table">
              <thead>
                <tr>
                  <th>symbol</th><th className="df-num">trades</th><th className="df-num">collected</th>
                  <th className="df-num">paid</th><th className="df-num">net p/l</th>
                </tr>
              </thead>
              <tbody>
                {symbols.map(r => (
                  <tr key={r.symbol}>
                    <td>{r.symbol}</td>
                    <td className="df-num">{r.trades}</td>
                    <td className="df-num">{money(r.received)}</td>
                    <td className="df-num">{money(r.paid)}</td>
                    <td className={`df-num ${tone(r.net)}`}>{signed(r.net)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </article>
      </div>
      <p className="df-muted df-foot">arr = net ÷ portfolio value, annualised over the month's elapsed days · average row sums $ and trades, means arr of active months</p>
    </div>
  );
}
